import { BroadcastMessagesService } from "@/BroadcastMessages/services/BroadcastMessages.Service";

export const actions = {
  async sendMessage({ commit }: any, message: any): Promise<void> {
    commit("setSendingMessage", true);

    await BroadcastMessagesService.sendMessage(message);

    commit("setSendingMessage", false);
  },

  async getBroadcastMessages({ commit }, channelIds: Array<string>): Promise<void> {
    commit("setLoadingPastMessages", true);

    commit("setPastMessages", []);

    const response = await BroadcastMessagesService.getBroadcastMessages(channelIds);

    commit("setPastMessages", response?.data?.data || []);

    commit("setLoadingPastMessages", false);
  },

  async getPubnubSubscriptionKeys(): Promise<void> {
    await BroadcastMessagesService.getPubnubSubscriptionKeys();
  }
};

export const mutations = {
  setLoadingPastMessages(state: any, value: any): void {
    state.loadingPastMessages = value;
  },

  setPastMessages(state: any, pastMessages: any): void {
    state.pastMessages = pastMessages;
  },

  setSendingMessage(state: any, value: any): void {
    state.sendingMessage = value;
  }
};

export const state = {
  loadingPastMessages: false,
  pastMessages: [],
  sendingMessage: false
};

const store: any = {
  actions,
  mutations,
  namespaced: true,
  state
};

export default store;
